import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { runtimeDb as db } from "../../firestoreStudio/runtime/runtimeDb";

/** Known collection relationships for the relationship viewer. */
export const COLLECTION_RELATIONSHIPS = [
  { from: "Employees", to: "Wins Attendance", field: "employeeId", foreignField: "employeeId" },
  { from: "Employees", to: "Branch Attendance", field: "employeeId", foreignField: "employeeId" },
  { from: "Employees", to: "payroll", field: "id", foreignField: "employeeId" },
  { from: "sales", to: "invoices", field: "invoiceId", foreignField: "id" },
  { from: "orders", to: "parties", field: "partyId", foreignField: "id" },
  { from: "items", to: "groups", field: "groupId", foreignField: "id" },
];

export function getRelationshipsFor(collectionName) {
  return COLLECTION_RELATIONSHIPS.filter(
    (r) => r.from === collectionName || r.to === collectionName
  );
}

export async function fetchLinkedDocuments(collectionName, docId, docData) {
  const rels = getRelationshipsFor(collectionName);
  const links = [];

  for (const rel of rels) {
    const isFrom = rel.from === collectionName;
    const targetCol = isFrom ? rel.to : rel.from;
    const localField = isFrom ? rel.field : rel.foreignField;
    const foreignField = isFrom ? rel.foreignField : rel.field;
    const linkValue = docData?.[localField];
    if (linkValue == null) continue;

    try {
      const snap = await getDocs(
        query(collection(db, targetCol), where(foreignField, "==", linkValue), limit(25))
      );
      links.push({
        collection: targetCol,
        field: foreignField,
        value: linkValue,
        documents: snap.docs.map((d) => ({ id: d.id, data: d.data() })),
      });
    } catch {
      links.push({ collection: targetCol, field: foreignField, value: linkValue, documents: [], error: true });
    }
  }

  return links;
}
